<template>
  <van-form @submit="onSubmit">
    <van-field
      v-model="imgsrc"
      label="图片链接"
      name="图片链接"
      placeholder="图片链接"
      :rules="[{ required: true, message: '请填写图片链接' }]"
    />
    <div style="margin: 16px">
      <van-button block native-type="submit" round type="info">
        上传至服务器
      </van-button>
    </div>

    <van-image height="100" :src="imgUrl" width="100" />
  </van-form>
</template>
<script>
  import { ref, onMounted } from 'vue'
  import api from '@/api'
  import { Notify } from 'vant'
  import { uploadFromUrl } from '@/utils'
  export default {
    setup(props) {
      //const FileHost = ref(api.FileHost)
      const imgsrc = ref(
        'http://wx.qlogo.cn/mmopen/g3MonUZtNHkdmzicIlibx6iaFqAc56vxLSUfpb6n5WKSYVY0ChQKkiaJSgQ1dZuTOgvLLrhJbERQQ4eMsv84eavHiaiceqxibJxCfHe/'
      )
      let imgUrl = ref('')

      const onSubmit = async () => {
        const { data } = await uploadFromUrl(imgsrc.value)
        if (data.Code === 0) {
          Notify({ type: 'success', message: '保存成功' })
          imgUrl.value = api.FileHost + data.Data
        }
      }

      return { imgsrc, onSubmit, imgUrl }
    },
  }
</script>
